import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faExclamation } from "web-fortawesome/npm/pro-light";

import { AsnNetDatabaseJournal } from "../../../../web-shared-components/asn1/EUCSrv/stubs/ENetUC_Journal";

interface ICallOriginIconProps {
	journalEntry: AsnNetDatabaseJournal;
}

export const CallOriginIcon = ({ journalEntry }: ICallOriginIconProps) => {
	const getCallOrigin = (iOrigin: number, callDurationSec: number) => {
		// iOrigin: 1 - outgoing, 0 - incoming
		if (iOrigin === 1 && callDurationSec > 0) return <FontAwesomeIcon width={12} icon={faArrowRight} />;

		if (iOrigin === 1 && callDurationSec === 0) return <FontAwesomeIcon width={12} icon={faArrowRight} />;

		if (iOrigin === 0 && callDurationSec > 0) return <FontAwesomeIcon width={12} icon={faArrowLeft} />;

		if (iOrigin === 1 && callDurationSec === 0) return <FontAwesomeIcon width={12} icon={faArrowLeft} />;

		return <FontAwesomeIcon width={12} icon={faExclamation} />;
	};

	return getCallOrigin(journalEntry.iOrigin, journalEntry.iDurationConnected);
};
